export interface AutoPrintRule {
  id: number;
  aeTitle: string | undefined;
  burnerName: string | undefined;
  readerName: string | undefined;
  includePdi: boolean;
  mode: PrintModeKey;
  timeout: number;
  enabled: boolean;
}

export type PrintModeKey = keyof typeof PrintMode;

export enum PrintMode {
  SINGLE_STUDY = 'Single study',
  PATIENT = 'Patient',
}

export default function autoPrintRules(state: AutoPrintRule[] = [], action: any): AutoPrintRule[] {
  switch (action.type) {
    case 'GET_AUTO_PRINT_RULES_FULFILLED':
      return action.response.data;
    default:
      return state;
  }
}